import { CSSProperties, ReactNode } from 'react';

export type KeyValueRow = { label: string; value: ReactNode };

const grid = (labelWidth: number): CSSProperties => ({
  display: 'grid',
  gridTemplateColumns: `${labelWidth}px minmax(0, 1fr)`,
  rowGap: 10,
  columnGap: 16,
  alignItems: 'baseline',
  margin: 0,
});

const labelStyle: CSSProperties = {
  fontSize: 12.5,
  color: 'var(--bui-fg-secondary)',
};

const valueStyle: CSSProperties = {
  margin: 0,
  fontSize: 13.5,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'wrap',
};

export const KeyValueGrid = ({
  rows,
  labelWidth = 190,
}: {
  rows: KeyValueRow[];
  labelWidth?: number;
}) => (
  <dl style={grid(labelWidth)}>
    {rows.map(row => (
      <div key={row.label} style={{ display: 'contents' }}>
        <dt style={labelStyle}>{row.label}</dt>
        <dd style={valueStyle}>{row.value}</dd>
      </div>
    ))}
  </dl>
);
